export default "__VITE_ASSET__BPccL97k__"